import { Inject, Injectable, InjectionToken } from '@angular/core';
import { SanterIntegrationInfo, SanterIntegrationResultData } from 'estensa-module';

import { ISeSignResultData, SeCompedSignInfo, SeSissSignInfo } from '../sign/estensasign.model';

export const ESTENSA_MODULE_IS_INTEGRATION_SERVICE = new InjectionToken('estensa.module.is-integration.service');

export interface IIsIntegrationWebServiceNg1 {
    onIsIntegrationActive(showNotification: boolean): void;

    onIsIntegrationNotActive(e: Error | null, showNotification: boolean): void;

    compedSignEx(info: SeCompedSignInfo): { $promise: Promise<ISeSignResultData[]> };

    sisswaySign(info: SeSissSignInfo): { $promise: Promise<ISeSignResultData[]> };

    sissSign(info: SeSissSignInfo): { $promise: Promise<ISeSignResultData[]> };

    startEstensa(): Promise<void>;

    santerIntegration(santerInfo: SanterIntegrationInfo): { $promise: Promise<SanterIntegrationResultData> };
}

export class NullIsIntegrationWebService implements IIsIntegrationWebServiceNg1 {
    onIsIntegrationActive() { /* This is intentional */
    }

    onIsIntegrationNotActive() { /* This is intentional */
    }

    async startEstensa() { /* This is intentional */
    }

    compedSignEx() {
        return { $promise: Promise.reject(new Error('You are using a null is integration service.')) };
    }

    sisswaySign() {
        return { $promise: Promise.reject(new Error('You are using a null is integration service.')) };
    }

    sissSign() {
        return { $promise: Promise.reject(new Error('You are using a null is integration service.')) };
    }

    santerIntegration() {
        return { $promise: Promise.reject(new Error('You are using a null is integration service.')) };
    }
}

@Injectable({
    providedIn: 'root',
})
export class IsIntegrationWebService {
    constructor(
        @Inject(ESTENSA_MODULE_IS_INTEGRATION_SERVICE) private isIntegrationService: IIsIntegrationWebServiceNg1,
    ) {
    }

    onIsIntegrationActive(showNotification = false) {
        this.isIntegrationService.onIsIntegrationActive(showNotification);
    }

    onIsIntegrationNotActive(e: Error | null, showNotification = false) {
        this.isIntegrationService.onIsIntegrationNotActive(e, showNotification);
    }

    compedSignEx(info: SeCompedSignInfo) {
        return this.isIntegrationService.compedSignEx(info).$promise;
    }

    sisswaySign(info: SeSissSignInfo) {
        return this.isIntegrationService.sisswaySign(info).$promise;
    }

    sissSign(info: SeSissSignInfo) {
        return this.isIntegrationService.sissSign(info).$promise;
    }

    private startEstensaRequest: Promise<void> | null = null;

    async startEstensa(): Promise<void> {
        if (!this.startEstensaRequest) {
            this.startEstensaRequest = this.isIntegrationService.startEstensa();
        }
        try {
            await this.startEstensaRequest;
        } finally {
            this.startEstensaRequest = null;
        }
    }

    santerIntegration(info: SanterIntegrationInfo): any /*Promise<SanterIntegrationResultData>*/ {
        return this.isIntegrationService.santerIntegration(info);
    }
}
